// Wybrany element menu: dostępne (sekcja "Twoje ankiety").
export const MENU_ITEM__QUESTIONNAIRES__AVAILABLE = 'QUESTIONNAIRES__AVAILABLE';
// Wybrany element menu: przydzielone (sekcja "Twoje formularze").
export const MENU_ITEM__FORMS__ASSIGNED = 'FORMS__ASSIGNED';
// Wybrany element menu: robocze (sekcja "Twoje formularze").
export const MENU_ITEM__FORMS__DRAFT = 'FORMS__DRAFT';
// Wybrany element menu: zwrócone (sekcja "Twoje formularze").
export const MENU_ITEM__FORMS__RETURNED = 'FORMS__RETURNED';
// Wybrany element menu: wysłane (sekcja "Twoje formularze").
export const MENU_ITEM__FORMS__SENT = 'FORMS__SENT';
// Wybrany element menu: zatwierdzone (sekcja "Twoje formularze").
export const MENU_ITEM__FORMS__APPROVED = 'FORMS__APPROVED';
// Wybrany kontent strony
// Ustawienia
export const AUTHORIZED_CONTENT_TYPE_USER_SETTINGS = 'AUTHORIZED_CONTENT_TYPE_USER_SETTINGS';
// Formularze
export const AUTHORIZED_CONTENT_TYPE_FOMRS = 'AUTHORIZED_CONTENT_TYPE_FOMRS';
